export const site = {
  name: "EasyBooks Solutions",
  tagline: "Simplifying business operations through ICT innovations.",
  contact: {
    email: "info@ebsolutionsmw.com",
    phone: "+265 884 675 719",
    address: "Area 47, sector 5, Near Zodiak Broadcasting Station",
  },
};

